var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1236 384L1236 412",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1236.5,
    cy: 379.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.1 388C1232.64 388 1232.24 387.834 1231.9 387.501C1231.57 387.168 1231.4 386.768 1231.4 386.3C1231.4 385.833 1231.57 385.432 1231.9 385.099C1232.24 384.766 1232.64 384.6 1233.1 384.6C1233.57 384.6 1233.97 384.766 1234.31 385.099C1234.64 385.432 1234.81 385.833 1234.81 386.3C1234.81 386.768 1234.64 387.168 1234.31 387.501C1233.97 387.834 1233.57 388 1233.1 388ZM1241.61 388C1241.14 388 1240.74 387.834 1240.41 387.501C1240.08 387.168 1239.91 386.768 1239.91 386.3C1239.91 385.833 1240.08 385.432 1240.41 385.099C1240.74 384.766 1241.14 384.6 1241.61 384.6C1242.08 384.6 1242.48 384.766 1242.81 385.099C1243.15 385.432 1243.31 385.833 1243.31 386.3C1243.31 386.768 1243.15 387.168 1242.81 387.501C1242.48 387.834 1242.08 388 1241.61 388ZM1232.38 374.4L1234.42 378.65H1240.38L1242.72 374.4H1232.38ZM1231.57 372.7H1244.12C1244.45 372.7 1244.7 372.845 1244.87 373.136C1245.04 373.426 1245.04 373.72 1244.89 374.018L1241.87 379.457C1241.71 379.741 1241.5 379.96 1241.24 380.116C1240.98 380.272 1240.69 380.35 1240.38 380.35H1234.04L1233.1 382.05H1243.31V383.75H1233.1C1232.47 383.75 1231.98 383.47 1231.66 382.911C1231.33 382.351 1231.32 381.795 1231.62 381.242L1232.76 379.16L1229.7 372.7H1228V371H1230.77L1231.57 372.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping2);
export default __webpack_public_path__ + "static/media/shopping_2.be7a31bd8455f0e2254a6c6f9be4f5dd.svg";
export { ForwardRef as ReactComponent };